<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Bloquear Espacios Disponibles</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area card-body">
            <div id="calendario">
              <full-calendar id="calendario_bloques_siccij" :events="eventosFullCalendar" :config="configuracionFullCalendar" ref="calendar" @event-selected="calendarioEventoClic"></full-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'
  import FullCalendar from '@/../static/js/fullcalendar'
  export default {
    data() {
      return {
        enumeraciones,
        comun,
        eventosFullCalendar: [],
        configuracionFullCalendar: {
          slotLabelFormat: 'hh:mma',
          header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
          },
          defaultView: 'agendaWeek',
          editable: false,
          businessHours: {
            daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
            start: '08:00:00', // a start time (10am in this example)  parametros.horarioAtencionInicio
            end: '16:00:00', // an end time (6pm in this example) parametros.horarioAtencionFinal
          },
          defaultDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          selectConstraint: "businessHours",
          weekends: false,
          minTime: '08:30',
          maxTime: '15:15',
          allDaySlot: false,
          defaultTimedEventDuration: '00:15:00',
          slotDuration: '00:15:00',
          slotLabelInterval: "01:00",
          selectable: false,
          height: 1000,
          contentHeight: 'auto'

        },
        idDelModelo: null
      }
    },
    props: {
      parametros: Object
    },
    mounted() {
      //console.log(this.parametros)
      this.obtenerCitasAgenda();
      //this.$store.dispatch("A_siccij_Catalogo_Establecer003Psicologo", parametros);
    },
    components: {
      FullCalendar
    },
    methods: {
      obtenerCitasAgenda: function () {
        var peticion = {
          "esPrueba": false,
          "AreaId": 1
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.MostrarAgendaBloqueos, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.eventosFullCalendar = response.data.AgendaEventosBloques;
            //this.insertarIcono();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      calendarioEventoClic: function (event, jsEvent, view) {
        console.log(event)
        var estatusBloqueId;
        if (event.title == "Disponible") {
          estatusBloqueId = 1;
        }
        else if (event.title == "Bloqueado") {
          estatusBloqueId = 3;
        }
        else {
          return;
        }
        this.bloquearEspacioDisponible(event.id, estatusBloqueId);
        //this.cambiarDatos(event);
      },
      bloquearEspacioDisponible: function (bloqueId, estatusBloqueId) {
        var peticion = {
          "esPrueba": false,
          "BloqueId": bloqueId,
          "EstatusBloqueId": estatusBloqueId
        };
        //console.log(peticion)
        //comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.BloquearEspacios, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.obtenerCitasAgenda();
            //this.insertarIcono();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          //comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }

    },
    created() {
      this.obtenerCitasAgenda();
    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
  .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }
</style>
<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_bloques_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_bloques_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_bloques_siccij .fc-axis {
    background-color: #004746;
    color: black !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_bloques_siccij .fc-day-header {
    background-color: #004746 !important;
    color: black !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_bloques_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_bloques_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_bloques_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_bloques_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: black !important;
  }

  #calendario_bloques_siccij .fc-day-number {
    color: black !important;
  }

  #calendario_bloques_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Administracion/BloquearEspaciosDisponibles/BloquearEspaciosDisponibles.vue